// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1oPUX","range":"MonthRangeSwitch_range__KvbVT","disabled":"MonthRangeSwitch_disabled__P9LlZ"};